// extracted by mini-css-extract-plugin
module.exports = {"isActive":"navigation_isActive__1H_T0"};